// extracted by mini-css-extract-plugin
module.exports = {"tag":"GbwGRi","shine-lines":"_3UD83-"};